/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS GPS lost detection api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * FeatureCollection Model
 * @export
 * @interface FeatureCollection
 */
export interface FeatureCollection {
    /**
     * 
     * @type {any}
     * @memberof FeatureCollection
     */
    bbox?: any | null;
    /**
     * 
     * @type {any}
     * @memberof FeatureCollection
     */
    type: any | null;
    /**
     * 
     * @type {any}
     * @memberof FeatureCollection
     */
    features: any | null;
}

/**
 * Check if a given object implements the FeatureCollection interface.
 */
export function instanceOfFeatureCollection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "features" in value;

    return isInstance;
}

export function FeatureCollectionFromJSON(json: any): FeatureCollection {
    return FeatureCollectionFromJSONTyped(json, false);
}

export function FeatureCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bbox': !exists(json, 'bbox') ? undefined : json['bbox'],
        'type': json['type'],
        'features': json['features'],
    };
}

export function FeatureCollectionToJSON(value?: FeatureCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bbox': value.bbox,
        'type': value.type,
        'features': value.features,
    };
}

